import * as yup from 'yup';
import { emailRegEx, onlyAcceptsNumber, phoneRegEx } from 'constants/regex';

// Unified public registration validation: ask once and reuse
export const PublicRegisterValidation = yup.object({
  companyName: yup.string().max(50, 'Max 50 characters').required('Company name is required'),
  companyAddress: yup.string().required('Company address is required'),
  homeAddress: yup.string().required('Home terminal address is required'),
  timeZone: yup.string().required('Time zone is required'),
  email: yup.string().matches(emailRegEx, 'Invalid email').required('Email is required'),
  phone: yup
    .string()
    .matches(phoneRegEx, 'Phone number is not valid')
    .max(15, 'Max 15 characters')
    .required('Phone is required'),
  usdot: yup
    .string()
    .matches(onlyAcceptsNumber, 'USDOT must be numeric')
    .max(12, 'Max 12 characters')
    .required('USDOT is required'),
});
